
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/members/[handle]/gear",
      function () {
        return require("private-next-pages/community/members/[handle]/gear.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/members/[handle]/gear"])
      });
    }
  